import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportTaskBurnDown_Settings {

    public daterange        : DateRange
    public projectId        : ID | null

    constructor(data: any) {
        this.daterange        = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectId        = _.get(data, "projectId", null)
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId        : this.projectId,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
